var React = require('react');

function AudioPause (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M43 84C65.6437 84 84 65.6437 84 43C84 20.3563 65.6437 2 43 2C20.3563 2 2 20.3563 2 43C2 65.6437 20.3563 84 43 84ZM43 86C66.7482 86 86 66.7482 86 43C86 19.2518 66.7482 0 43 0C19.2518 0 0 19.2518 0 43C0 66.7482 19.2518 86 43 86Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M36 57.5V28H39V57.5H36Z","fill":"white","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M47.5 57.5V28H50.5V57.5H47.5Z","fill":"white","key":2})]);
}

AudioPause.defaultProps = {"width":"86","height":"86","viewBox":"0 0 86 86","fill":"none"};

module.exports = AudioPause;

AudioPause.default = AudioPause;
